var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-mt",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce0000",
    d: "M320 0h320v480H320z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h320v480H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.4 -30.8) scale(1.5986)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1eeee",
    fillRule: "evenodd",
    d: "M104.8 108c0 .9-.9 1.5-2 1.5-1.2 0-2-.6-2-1.4 0-.8.8-1.5 2-1.5 1.1 0 2 .7 2 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    fillRule: "evenodd",
    d: "M40.7 101v37.2H78c0 6.2 6.2 12.4 12.4 12.4v37.2h37.3v-37.2c6.2 0 12.4-6.2 12.4-12.4h37.2V101H140c0-6.2-6.2-12.4-12.4-12.4V51.4H90.4v37.2c-6.3 0-12.5 6.2-12.5 12.4H40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe600",
    fillRule: "evenodd",
    d: "M42 102.2V137h37.2c0 6.2 6.2 12.4 12.4 12.4v37.2h34.7v-37.1c6.2 0 12.4-6.2 12.4-12.4H176v-34.8h-37.2c0-6.2-6.2-12.4-12.4-12.4V52.6H91.6v37.2c-6.2 0-12.4 6.2-12.4 12.4H42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M43.2 103.5v32.2h37.2c0 6.2 6.2 12.4 12.4 12.4v37.2h32.3v-37.2c6.2 0 12.4-6.2 12.4-12.4h37.2v-32.2h-37.2c0-6.2-6.2-12.4-12.4-12.4V53.9H92.8V91c-6.2 0-12.4 6.2-12.4 12.4H43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a0a0",
    fillRule: "evenodd",
    d: "M44.5 104.7v29.8h37.2c0 6.2 6.2 12.4 12.4 12.4V184h29.7v-37.2c6.2 0 12.4-6.2 12.4-12.4h37.2v-29.8h-37.2c0-6.2-6.2-12.4-12.4-12.4V55.1H94.1v37.2c-6.2 0-12.4 6.2-12.4 12.4H44.4z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M94.4 89.2c2.1 2.2.4 7.5-4 11.9s-9.6 6-11.8 4c-2.2-2.3-.4-7.6 4-12s9.6-6 11.8-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M91.7 91.8c2.2 2.2 1.6 6.3-1.3 9.3s-7 3.5-9.2 1.3c-2.2-2.2-1.6-6.3 1.3-9.2s7-3.5 9.2-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "m80.8 98.4.8-.8 3.5 1.7-1.7-3.5.9-.9 3.5 7-7-3.5zm5.2-5.2 1-1 5.2 5.4-.9.8z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M139.3 105c-2.2 2.2-7.5.4-11.8-4s-6.2-9.6-4-11.8c2.2-2.2 7.5-.4 11.9 4s6 9.6 4 11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M136.7 102.4c-2.2 2.2-6.3 1.6-9.2-1.3s-3.5-7-1.4-9.2c2.2-2.2 6.4-1.6 9.3 1.3s3.5 7 1.3 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "m130.1 91.4.9.9-1.8 3.5 3.5-1.8 1 1-7.1 3.4 3.5-7zm5.3 5.3.8.8-5.2 5.3-.9-.9z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M123.5 150c-2.2-2.2-.4-7.5 4-11.9s9.6-6.1 11.8-4c2.2 2.2.4 7.5-4 11.9s-9.6 6.1-11.8 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M126.2 147.3c-2.2-2.2-1.6-6.3 1.3-9.2s7-3.5 9.2-1.3c2.2 2.2 1.6 6.3-1.3 9.2s-7 3.5-9.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "m137.1 140.7-.9 1-3.5-1.8 1.8 3.5-.9.8-3.5-7 7 3.5zM132 146l-1 .9-5.2-5.3.9-.9z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "M78.6 134.2c2.2-2.2 7.5-.4 11.8 3.9s6.1 9.7 4 11.8c-2.2 2.2-7.5.5-11.9-3.9s-6-9.7-4-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M81.2 136.8c2.2-2.2 6.3-1.6 9.2 1.3s3.5 7 1.3 9.2c-2.1 2.2-6.3 1.6-9.2-1.3s-3.5-7-1.3-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "m87.8 147.8-.9-1 1.8-3.4-3.5 1.7-1-.9 7.1-3.5-3.5 7zm-5.3-5.3-.8-.9 5.2-5.2.9.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    strokeWidth: "1pt",
    d: "M269.3 414.6c0 41-34.1 74.4-76.2 74.4S117 455.7 117 414.6s34.1-74.4 76.2-74.4 76.2 33.3 76.2 74.4z",
    transform: "matrix(.34191 0 0 .35003 43 -25.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    strokeWidth: "1pt",
    d: "M269.3 414.6c0 41-34.1 74.4-76.2 74.4S117 455.7 117 414.6s34.1-74.4 76.2-74.4 76.2 33.3 76.2 74.4z",
    transform: "matrix(.2605 0 0 .26669 58.6 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    d: "M100.3 140.7a1.2 1.2 0 1 1-2.5 0 1.2 1.2 0 0 1 2.5 0zm19.8 0a1.2 1.2 0 1 1-2.5 0 1.2 1.2 0 0 1 2.5 0zm-12 0v1.3h-1.6c-1.7 0-1.7 1.3 0 1.3h1.6v1.2c0 1.4 1.5 1.5 1.6.1v-1.4h1.7c1.7 0 1.7-1.2 0-1.2h-1.6v-1.3c0-1.3-1.7-1.3-1.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    stroke: "#707070",
    strokeWidth: 0.1,
    d: "M102.8 122.3v.8s-.4.5-2.9.7c-2.5.2-2.9 0-2.9 0 .1.7.6 1.9.4 3.3.1 1.7-.4 3.2-.4 3.2 0 .1-.3.2-.8.1.4-.4.4-1.4.4-3 0-1.4-1.5-3.7-1.2-4.3.3-.6 7.4-.8 7.4-.8zm9.8-2.6 6.5-.1s1 2 .9 3c0 1-.4 2-.8 1.5-.5-.5.2-.4.3-1.5 0-1.2-.8-2.3-.8-2.3s-1.8.7-4.4.6c-2.6-.2-1.4-1.2-1.7-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    stroke: "#707070",
    strokeWidth: 0.1,
    d: "M113.4 121.6c2.4-.1 4 .2 4 .2s1 2 1 3c-.1 1-.4 2-.9 1.5-.4-.4.2-.3.3-1.5 0-1.1-.8-2.3-.8-2.3s-1.7.7-4.3.6c-2.6-.2-1.8-.3-2.1-.4-.3 0-.4.8-4.3.9-4 0-6-.9-6-.9s-.4.6-2.8.8h-3c.1.6.6 1.8.5 3.3 0 1.6-.5 3.2-.5 3.2h-.7c.4-.3.3-1.4.4-2.9 0-1.5-1.6-3.7-1.3-4.4.4-.6 2.2 0 2.5-.3.3-.4-1.6-2.7-1.2-4.8.3-2.1 2.4-1.5 4.9-1.5 2.5.1 8 .8 9.4 0 1.4-.7.8-3.4 2-5.1a4.1 4.1 0 0 1 3.3-1.5c.9 0 2 3 2 3.7l-.3.4h-.4v.3c-1 .1-1.1-.8-1.7-1.4-.2 1 .8 4.4.8 6.6 0 1.8-.7 2.6-.8 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    stroke: "#707070",
    strokeWidth: 0.1,
    d: "M105.5 118.4c0 .7-3.1 2.4-3.4 3-.2.7.8 1 .5 1.4-.3.4-.6.2-.7.3l-1.2-2.5s3-1.4 2.9-2c-.1-.6-2.2-1-2.6-2.4s-.2-4.3-.5-4.9c-.3-.6-4-1.2-4-2 0-1 3.8-3.4 4.2-3.8.4-.4.8.4.4.7-.4.4-3.3 2.7-3.3 3 0 .4 2.4.8 3.2.8.9 0 1.3-.4 1.3-.8 0-.3-.9-.3-.9-1s.5-1.2 1.3-1.2c.4 0 1.2.5 1.2 1.1s-.7.7-.8 1.1c-.1.5.8.8 1.6.8s3.6 2.1 4 2.5c.5.3.9.3.5.7-.4.4-.2.8-.6.4a1.5 1.5 0 0 1-.4-.7c0-.3-3-1.8-3.5-1.5-.4.4 0 4.8 0 5.2 0 .7.9.7.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7a7a7",
    fillRule: "evenodd",
    d: "M100.3 109.9h5v5.1h-5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.6,
    height: 0.4,
    x: 138.6,
    y: -25.7,
    fill: "gray",
    fillRule: "evenodd",
    rx: 0.5,
    ry: 0.2,
    transform: "matrix(.55442 .83223 -.88237 .47055 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    stroke: "#707070",
    strokeWidth: "1pt",
    d: "M180.7 42.5a7 7 0 1 1-14.2 0 7 7 0 0 1 14.2 0z",
    transform: "matrix(.11563 0 0 .10345 80.7 101.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M115.9 112.5c0 .3-2 .7-4.1.7-2.2 0-4.1-.4-4.1-.7 0-.3 1.9.5 4 .5 2.3 0 4.2-.8 4.2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7a7a7",
    fillRule: "evenodd",
    d: "M100.7 115h4.1v1.5h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M114 111.4c-.4.8-.7 1.3-.8 1.2 0 0 .2-.8.6-1.5l.8-1.2c.1.1-.2.8-.6 1.5zm1 2-.8.5a3.2 3.2 0 0 1 .8-.9c.5-.4.9-.6.9-.5l-.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "m114.6 112.4.5 1.2-.8-1-.5-1.2.8 1zm-.4 3.2s-1.2.2-2.8.2-2.9-.1-2.9-.2l2.9-.2c1.6 0 2.8 0 2.8.2zm-9.4-.4c0 .1-.9.2-2 .2-1.2 0-2 0-2-.2 0 0 .8-.2 2-.2 1.1 0 2 .1 2 .2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    fillRule: "evenodd",
    stroke: "gray",
    strokeWidth: 0.1,
    d: "M95.8 128s.7 1.6 3.6 1.6c2.8 0 3.8-.5 2.7-1.3s-3.4-.6-3 .1c.2.8-.9 1-1.1.5-.3-.5-1.3-2.1.5-2.2 1.9-.1 5.8-.7 6.8.4s-1.1 2 .5 2.3c1.5.2 1.8-.3 4.5-.4 2.7-.2 3.8.5 4.7.4 1 0 .8-1.7 0-2-.7-.5-2.1-.6-2.5-1-.3-.5-1.3 0-1.2-.6 0-.5 1.4.3 1.4.1l.2-.2h-.3l.1-.2-.2.1.1-.2s-.3.2-.3 0h-.2c.2-.2.1-.2 0-.3h-.3v-.3c-.2 0-.2 0-.3.2v-.5c0-.1.2-.2.5-.2.7 0 1 .8 1.3.8.2 0 .5-.8 1.4-.5l1.5.6c.5.3-.3.6 0 1s2.1 1.7 1.6 3.2c-.5 1.4-2 1.6-2 2.2-.2.6 4.3.4 5.4.6a3 3 0 0 1 1.9 1.2l-2 .1s-1-.5-3.5-.6c-2.5 0-3.4-1-4.4-1.2l-4 .2-3-.3c-.6-.1-4.2 1.6-4.2 2h-2.4s.3-.9 1.7-1c1.3-.2 2.7-.8 2.6-1.2l.4-2.6c0-.6.6-1 .5-1.2-.1-.4-1.7-.7-3.2-.7-1.5 0-3.1.1-3.4.4-.2.4 0 1.5.3 1.3.3 0-.1-.8.2-.9a6.8 6.8 0 0 1 2-.3c.8 0 2.1.7 2.1 1 0 .1.4.8-.2 1.1a8.2 8.2 0 0 1-3.1.4 7.5 7.5 0 0 1-3-.8c-.4-.3-.7-1-.7-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M114 125.5a.3.3 0 1 1-.6 0 .3.3 0 0 1 .6 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d0d0d0",
    d: "m129.5 120.8 1.6.3 2.7-1.8-.2 1-1.4.9-.8.4.5.8.9 1.4-.2 1-1.7-2.9-1.6-.3.2-.8zm-2.7-11.8 3-1.4-.8-1.8.4-.2 2 4.4-.3.2-.9-1.9-3 1.5-.4-.8zm-4.8-5.8 2.8-2.6.6.6v4.4l2.2-2 .5.6-2.8 2.6-.6-.6v-4.4l-2.2 2-.5-.6zm-12.4-5 .5-3.8h.8l-.5 3.5 3 .3v.5l-3.8-.5zm-6.1.6-.7-3.8.8-.2.6 3.4 3-.6v.5l-3.7.7zm-11.3 5.5-.3-.3 2-1.6 1 1a5.7 5.7 0 0 1-.8 1.2 5.7 5.7 0 0 1-.9 1 5.2 5.2 0 0 1-1.4.8c-.5.1-1 .2-1.3 0a1.6 1.6 0 0 1-1-.5 1.7 1.7 0 0 1-.3-1c0-.4.1-.9.4-1.3.2-.4.6-.8 1-1.1a4.8 4.8 0 0 1 1.1-.7l.9-.2c.2 0 .5 0 .7.2l-.4.5a1.3 1.3 0 0 0-.6-.1l-.6.1a3.2 3.2 0 0 0-.7.5c-.3.2-.6.4-.7.7a2 2 0 0 0-.4.6v.5c0 .3.1.6.3.8l.7.5 1-.1a4.1 4.1 0 0 0 2.1-2l-.4-.6-1.4 1.1zm-.1 27.7-3.2 2.3-2.4-3.4.4-.3 2 2.7.9-.7-1.6-2.3.3-.2 1.7 2.3 1.4-1 .5.6zm-4.7-5c.5-.1.8-.4 1-.9v-1.5a2.6 2.6 0 0 0-.9-1.3c-.3-.3-.8-.4-1.2-.3a1.4 1.4 0 0 0-.8.5c-.1.2-.3.5-.3.8l.1 1.1c.2.6.4 1 .8 1.4.3.3.8.4 1.3.2zm.3.8a1.7 1.7 0 0 1-1.7-.4 3.7 3.7 0 0 1-1.1-1.8c-.2-.6-.2-1-.2-1.6s.2-.8.4-1.1a1.6 1.6 0 0 1 1-.7 1.6 1.6 0 0 1 1 .1c.4.2.7.4 1 .8a4.5 4.5 0 0 1 .8 3 2.3 2.3 0 0 1-.4 1.1c-.2.3-.5.5-.8.6zm.3-7.8h-4v-2.8l.2-1.2.4-.7a.8.8 0 0 1 .6-.2c.3 0 .5.1.7.4.1.3.3.7.3 1.3a2.5 2.5 0 0 1 .7-1.1l1.1-1v1l-.8.7-.6.6a1.7 1.7 0 0 0-.3.4 1.6 1.6 0 0 0 0 .4v.4l-.1 1H88v.8zm-2.2-.9v-1.7a4 4 0 0 0 0-.9 1 1 0 0 0-.2-.4.5.5 0 0 0-.3-.2c-.2 0-.4.1-.5.3l-.2 1v2h1.3zm10.7-16.9v-4.5l.8-.5 4.1 2-.8.5-1.2-.6-2.1 1.3v1.4l-.8.4zm.7-2.3 1.8-1-1-.6a8.3 8.3 0 0 1-.9-.5l.1.8v1.3zm18.6-1.2L120 97l.7.5-.3 4.6-.7-.6.1-1.3-2-1.5-1.3.5-.7-.5zm2.4-.2 1.7 1.2v-1.2a8.4 8.4 0 0 1 .2-1 3.7 3.7 0 0 1-.7.5l-1.2.5zm10.3 14.3 3.8-.9.6 2.7.2 1.2-.2.7a.8.8 0 0 1-.5.4c-.3 0-.6 0-.8-.2a2.8 2.8 0 0 1-.7-1.2 2.5 2.5 0 0 1 0 .5l-.4.8-.8 1.2-.2-1 .6-1 .4-.6a1.6 1.6 0 0 0 .2-.8 3.7 3.7 0 0 0-.1-.5l-.2-.9-1.7.4-.2-.8zm2.3.3.4 1.7c0 .3.2.6.3.8 0 .2.2.3.3.4l.4.1c.1 0 .3-.2.3-.4a2.1 2.1 0 0 0 0-1l-.5-1.9-1.2.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.a39094a015bbe6ba386122e4d23918eb.svg";
export { ForwardRef as ReactComponent };